import client from '@stores/apollo'
import gql from 'graphql-tag'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  approveEmployeeImport: {
    employee_import: { id: string; status: string }
  }
}

const mutateHandler = handleFetchResult<IPayload, { id: string; status: string }>({
  handler: (data) => data.approveEmployeeImport.employee_import,
  name: 'approveEmployeeImport',
})

export default function approveEmployeeImport(
  employeeImportId: string
): Promise<{ id: string; status: string }> {
  return client.gql
    .mutate({ mutation, variables: { input: { employeeImportId } } })
    .then(mutateHandler)
}

const mutation = gql`
  mutation approveEmployeeImport($input: ApproveEmployeeImportInput!) {
    approveEmployeeImport(input: $input) {
      employee_import {
        id
        status
      }
    }
  }
`
